module.exports = new __parcel__URL__("metamask.3dc053f7.png").toString();